import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService, SupabaseBaseHttpService, TableRowModel } from '@examdojo/supabase';
import { from } from 'rxjs';

export type ReviewContentChatHttpModel = TableRowModel<'content_chats', 'review'>;

@Injectable({
  providedIn: 'root',
})
export class ReviewContentChatsHttpService extends SupabaseBaseHttpService<'content_chats', 'review'> {
  constructor(protected override readonly supabase: ExamdojoSupabaseService) {
    super(supabase);
  }

  readonly schema = 'review';
  readonly tableName = 'content_chats';

  createContentChat(reviewableItemId: string, contentJsonPath: string) {
    const query = this.supabase.client
      .schema(this.schema)
      .from(this.tableName)
      .insert({
        reviewable_item_id: reviewableItemId,
        content_json_path: contentJsonPath,
        llm_chat_id: null as unknown as number, // will be overridden by trigger
      })
      .select()
      .single();

    return from(query.throwOnError().then((response) => response.data!));
  }

  fetchByReviewableItem(reviewableItemId: string, createdBy: string) {
    const query = this.supabase.client
      .schema(this.schema)
      .from(this.tableName)
      .select()
      .eq('reviewable_item_id', reviewableItemId)
      .eq('created_by', createdBy)
      .order('created_at', { ascending: false });

    return from(query.throwOnError().then((response) => response.data!));
  }

  fetchByLlmChatId(llmChatId: number) {
    const query = this.supabase.client
      .schema(this.schema)
      .from(this.tableName)
      .select()
      .eq('llm_chat_id', llmChatId)
      .single();

    return from(query.throwOnError().then((response) => response.data!));
  }
}
